if (themeVars['single-type'] == 'ultimate_guides') {
    $(document).ready(function () {
        let allHeadings = $('.entry-content h2');
        let tableOfContents = $('.table-of-contents__list');
        allHeadings.each(function () {
            let headingIcon = $(this).attr('data-icon');
            let headingId = $(this).attr("id");
            let headingText = $(this).text();
            let listItem = '<li class="toc-list__item" style="background-image:url(' + headingIcon + ')"><a href="#' + headingId + '">' + headingText + '</a></li>'
            tableOfContents.append(listItem);
        });
    });

    $(document).on('click', '.toc-list__item a', function () {
        if (this.hash !== "") {
            var hash = this.hash;
            $('html, body').animate(
                { scrollTop: $(hash).offset().top - 39 }, 800);
        }
    })
    $('.travel-way__read-more').click(function () {
        $(this).parent().find('.travel-way__content').toggleClass('open');
        $(this).find('span').toggleHtml(translations.readMore, translations.hide);
        $(this).find('span').toggleClass("less-info");
    })

    $('.table-of-contents__read-more').click(function () {
        $('.toc-list').children().toggleClass('show');
        $(this).find('span').toggleHtml(translations.viewAll, translations.viewLess);
        $(this).find('span').toggleClass("less-info");
    })
}
let hotelContainer = $('.hotels-list');
if ($('.hotels-list')[0]) {
    hotelContainer.each(function () {
        if ($(this).children().length > 2) {
            $(this).slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                focusOnSelect: true,
                appendDots: $('.slider-nav_hotel'),
                nextArrow: '<button type="button" class="slick-next"></button>',
                prevArrow: '<button type="button" class="slick-prev"></button>',
                touchMove: false,
            });
        }
    });
}
if ($('.pillar-slider-block__list.slider')[0]) {
    $('.pillar-slider-block__list.slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: true,
        appendDots: $('.slider-nav_hotel'),
        nextArrow: '<button type="button" class="slick-next"></button>',
        prevArrow: '<button type="button" class="slick-prev"></button>',
        touchMove: false,
    });
}


// WEBPACK FOOTER //
// ./scripts/modules/pillar-page.js